import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RecordJobSeenMutationVariables = Types.Exact<{
  input: Types.RecordJobSeenInput;
}>;


export type RecordJobSeenMutation = { __typename?: 'Mutation', recordJobSeen?: { __typename?: 'RecordJobSeenPayload', ctk: string } | null };


export const RecordJobSeenDocument = gql`
    mutation recordJobSeen($input: RecordJobSeenInput!) {
  recordJobSeen(input: $input) {
    ctk
  }
}
    `;
export type RecordJobSeenMutationFn = Apollo.MutationFunction<RecordJobSeenMutation, RecordJobSeenMutationVariables>;

/**
 * __useRecordJobSeenMutation__
 *
 * To run a mutation, you first call `useRecordJobSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordJobSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordJobSeenMutation, { data, loading, error }] = useRecordJobSeenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordJobSeenMutation(baseOptions?: Apollo.MutationHookOptions<RecordJobSeenMutation, RecordJobSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordJobSeenMutation, RecordJobSeenMutationVariables>(RecordJobSeenDocument, options);
      }
export type RecordJobSeenMutationHookResult = ReturnType<typeof useRecordJobSeenMutation>;
export type RecordJobSeenMutationResult = Apollo.MutationResult<RecordJobSeenMutation>;
export type RecordJobSeenMutationOptions = Apollo.BaseMutationOptions<RecordJobSeenMutation, RecordJobSeenMutationVariables>;